import { useEffect } from "react";
import TermlyEmbed from "./TermlyEmbed";

const PrivacyPolicy = () => {
  useEffect(() => {
    document.title = "Privacy Policy | Kloudscan";
  }, []);

  return <TermlyEmbed policyId="e220009e-ceee-49d9-aead-5c0e4fd8f19e" label="Privacy Policy" />;
};

export default PrivacyPolicy;
